<template>
<f7-navbar>
  <f7-nav-left>
    <f7-link back v-if="back">
      <img class="margin-right" src="@/assets/icons/back.png" width="24">
      <span>Back</span>
    </f7-link>
  </f7-nav-left>
  <f7-nav-title :title="title"/>
  <f7-nav-right>
    <f7-link @click="exitApp">
      <img src="@/assets/icons/home.png" width="50">
    </f7-link>
  </f7-nav-right>
</f7-navbar>
</template>

<script>
import { confirm, exitApp } from '@/lib/helper'

export default {
  props: {
    title: { type: String, default: '' },
    back: { type: Boolean, default: true }
  },

  methods: {
    exitApp () {
      confirm(
        'Tips',
        'Are you sure you want to exit the application?',
        () => exitApp()
      )
    }
  }
}
</script>
